import { SystemIcon, systemIconStencil } from '@workday/canvas-kit-react/icon';
import { createStencil, handleCsProp } from '@workday/canvas-kit-styling';
import { WcpStyles } from '@workday/wcp-tokens';
import React from 'react';

export interface ThemedSystemIconProps extends React.ComponentProps<typeof SystemIcon> {
  colorHover?: string;
}

export const ThemedSystemIcon: React.FC<ThemedSystemIconProps> = ({
  color = WcpStyles.color.icon.strong,
  colorHover = WcpStyles.color.icon.strong,
  ...props
}) => {
  return <SystemIcon {...handleCsProp(props, [iconStencil({ color, colorHover })])} />;
};

const iconStencil = createStencil({
  extends: systemIconStencil,
  vars: {
    color: WcpStyles.color.icon.strong,
    colorHover: WcpStyles.color.icon.strong,
  },
  base: ({ color, colorHover }) => ({
    [systemIconStencil.vars.color]: color,
    '&:hover': {
      [systemIconStencil.vars.color]: colorHover,
    },
  }),
});
